/* External dependencies */
import { Dispatch } from "redux";

/* Local dependencies */
import {
  ActionTypesUser,
  ISpecialist,
  ISpecialistCategory,
  InterfaceUserTypes,
} from "../types/Types";
import { API_ADDRESS } from "../../../../Api";
import axios from "axios";

export const ActionGetDoctors = () => {
  return async (dispatch: Dispatch<ActionTypesUser>) => {
    try {
      dispatch({ type: InterfaceUserTypes.DOCTORS_LOADER, payload: true });

      const { data: categories } = await axios.get<ISpecialistCategory[]>(
        `${API_ADDRESS}users/specialist_categories/`
      );

      const { data: doctors } = await axios.get<ISpecialist[]>(
        `${API_ADDRESS}users/doctor_contacts/`
      );

      dispatch({ type: InterfaceUserTypes.DOCTORS_LOADER, payload: false });

      dispatch({
        type: InterfaceUserTypes.DOCTORS,
        payload: { doctors, categories },
      });
    } catch (e) {
      dispatch({ type: InterfaceUserTypes.DOCTORS_LOADER, payload: false });
      dispatch({ type: InterfaceUserTypes.DOCTORS_ERROR, payload: e });
    }
  };
};
